// extracted by mini-css-extract-plugin
export default {"SubmitButton":"EditBankAccount_SubmitButton__NVleq"};